import React from 'react';
import Combobox from '@ls/react-combobox-grid';
import { useDispatch, useSelector } from 'react-redux';
import SelectionState from 'state/selections/SelectionState';
import { setOfferingMarketsFilter } from 'state/selections/actions';
import offeringMarkets, { offeringMarketColumnDef } from 'state/selections/OfferingMarkets';
import { selectSelectedOfferingMarketsValues } from 'state/selections/selectors';

const OfferingMarketFilter = () => {
  const dispatch = useDispatch();
  const values = useSelector(
    selectSelectedOfferingMarketsValues(SelectionState.UNCOMMITTED)
  );

  const onChange = React.useCallback(
    offeringMarkets => {
      dispatch(setOfferingMarketsFilter(offeringMarkets));
    },
    [dispatch]
  );

  return (
    <Combobox
      options={offeringMarkets}
      onChange={onChange}
      value={values}
      placeholder="Offering Markets..."
      label="Offering Markets:"
      valueKey="offeringMarket"
      labelKey="offeringMarketDesc"
      columnDefs={offeringMarketColumnDef}
      variation={1}
      multi
    />
  );
};

export default OfferingMarketFilter;